import { simplifyQueryObject } from '@helpers/core/simplifyQueryObject'
import { isEmpty } from '@helpers/core/isEmpty'
import {
  convertToQueryString,
  parseQueryString,
} from '@helpers/core/queryString'
import { URL_PARAMS } from '@constants/urlParams'

type getUniqueQueryStringOptions = {
  url: string
  search: string | object
  allowedQueryStrings?: string[]
}

export function getUniqueQueryString({
  url,
  search,
  allowedQueryStrings = URL_PARAMS,
}: getUniqueQueryStringOptions) {
  if (isEmpty(search)) {
    return url
  }

  let searchObject

  if (typeof search === 'string') {
    searchObject = parseQueryString(search)
  } else {
    searchObject = search
  }

  // Turn stuff like this `adgroupid[0]=foo&adgroupid[1]=foo` to `adgroupid=foo`.
  const query = simplifyQueryObject(searchObject)

  // Find the allowed query strings and filter out empty queries.
  const goodQueries = Object.keys(query).filter(
    queryKey =>
      allowedQueryStrings.includes(queryKey) && Boolean(query[queryKey])
  )

  // Pick the good ones from the request.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const newQuery = goodQueries.reduce((acc: Record<string, any>, queryKey) => {
    acc[queryKey] = query[queryKey]

    return acc
  }, {})

  // Build the full URL.
  return `${url}${convertToQueryString(newQuery, { addQueryPrefix: true })}`
}
